/* This example requires Tailwind CSS v2.0+ */
import React, { Fragment } from 'react';
import { Popover, Transition } from '@headlessui/react';

interface DropdownMenuProps {
  button: JSX.Element;
  children: JSX.Element;
}

export const DropdownPopover = ({ button, children }: DropdownMenuProps) => (
  <Popover as='nav'>
    <Popover.Button as={Fragment}>{button}</Popover.Button>
    <Transition
      as={Fragment}
      enter='transition ease-out duration-200'
      enterFrom='opacity-0 translate-y-1'
      enterTo='opacity-100 translate-y-0'
      leave='transition ease-in duration-150'
      leaveFrom='opacity-100 translate-y-0'
      leaveTo='opacity-0 translate-y-1'>
      <Popover.Panel className='absolute z-10 right-0 top-4 mt-3 px-2 w-screen max-w-md sm:px-0'>
        {children}
      </Popover.Panel>
    </Transition>
  </Popover>
);
